import React from 'react'

import { Heading } from '@/components/ui/heading'
import { cn } from '@/lib/utils'

type Props = Omit<React.ComponentProps<typeof Heading>, 'size'>

const SectionHeading: React.FC<Props> = ({ className, style, ...props }) => (
  <Heading
    size={2}
    className={cn('mb-2 font-semibold', className)}
    style={{ fontSize: '17px', ...style }}
    {...props}
  />
)

export default SectionHeading
